// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#profile {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
}

#profile #filters {
  align-items: center;
  display: flex;
  justify-content: space-around;
  margin: 2vh 7.5%;  
}

#profile #filters .filter {
  margin-right: 0;
}

#profile #filters .filter img {
  cursor: pointer;
  margin-bottom: 0.2rem;
}

#profile #card {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 2vh;
  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
  overflow: hidden;
  padding: 0 5%;
  width: 85%;
}

#profile #card .header {
  margin: 2vh 0;
  text-align: right;
  width: 100%;
}

#profile #card .body {
  align-items: center;
  color: #07144C;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  width: 100%;
}

#profile #card .body .label {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 3vh;
  text-align: center;
}

#profile #card .body .prompt {
  font-size: 4vh;
  text-align: center;
}

#profile #card .body .value {
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  font-size: 5vh;
  font-weight: bold;
  line-clamp: 3;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  width: 100%;
  word-wrap: break-word;
}

#profile #card .footer {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 2vh 0;
  width: 100%;
}

#profile #card #close {
  cursor: pointer;
  height: 1.33rem;
  width: 1.33rem;
}

#profile #card #edit {
  cursor: pointer;
  height: 1.33rem;
  width: 1.33rem;
}

#profile #card .text-input {
  width: 100%;
}

#profile #card .values {
  margin: 1rem 0;
  overflow: auto;
  width: 100%;
}

#profile #card.select .box {
  background-color: #FFD55D;
  border-radius: 2vh;
  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);
  color: #07144C;
  cursor: pointer;
  font-size: 1.25rem;
  margin-top: 1rem;
  padding: 2vh 0;
  text-align: center;
}

#profile #card.select .footer {
  display: none;
}

#profile #card.text .values {
  display: none;
}

#profile #pager {
  height: 0.67rem;
  margin: 2vh 7.5%;
}

#profile #reset {
  height: 2rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/profile/Profile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb","sourcesContent":["#profile {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n}\n\n#profile #filters {\n  align-items: center;\n  display: flex;\n  justify-content: space-around;\n  margin: 2vh 7.5%;  \n}\n\n#profile #filters .filter {\n  margin-right: 0;\n}\n\n#profile #filters .filter img {\n  cursor: pointer;\n  margin-bottom: 0.2rem;\n}\n\n#profile #card {\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 2vh;\n  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: 0 auto;\n  overflow: hidden;\n  padding: 0 5%;\n  width: 85%;\n}\n\n#profile #card .header {\n  margin: 2vh 0;\n  text-align: right;\n  width: 100%;\n}\n\n#profile #card .body {\n  align-items: center;\n  color: #07144C;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  width: 100%;\n}\n\n#profile #card .body .label {\n  font-size: 1rem;\n  font-weight: bold;\n  margin-bottom: 3vh;\n  text-align: center;\n}\n\n#profile #card .body .prompt {\n  font-size: 4vh;\n  text-align: center;\n}\n\n#profile #card .body .value {\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  font-size: 5vh;\n  font-weight: bold;\n  line-clamp: 3;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  width: 100%;\n  word-wrap: break-word;\n}\n\n#profile #card .footer {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin: 2vh 0;\n  width: 100%;\n}\n\n#profile #card #close {\n  cursor: pointer;\n  height: 1.33rem;\n  width: 1.33rem;\n}\n\n#profile #card #edit {\n  cursor: pointer;\n  height: 1.33rem;\n  width: 1.33rem;\n}\n\n#profile #card .text-input {\n  width: 100%;\n}\n\n#profile #card .values {\n  margin: 1rem 0;\n  overflow: auto;\n  width: 100%;\n}\n\n#profile #card.select .box {\n  background-color: #FFD55D;\n  border-radius: 2vh;\n  box-shadow: 0 3.5px 6px rgba(0, 0, 0, 0.05);\n  color: #07144C;\n  cursor: pointer;\n  font-size: 1.25rem;\n  margin-top: 1rem;\n  padding: 2vh 0;\n  text-align: center;\n}\n\n#profile #card.select .footer {\n  display: none;\n}\n\n#profile #card.text .values {\n  display: none;\n}\n\n#profile #pager {\n  height: 0.67rem;\n  margin: 2vh 7.5%;\n}\n\n#profile #reset {\n  height: 2rem;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
